import React from 'react'
import ServiceCardStyle from './ServiceCardStyle'

const ServiceCard = ({ icon, header, text, alt }) => {
  //
  return (
    <ServiceCardStyle>
      <div className="just-start">
        <div>
          <img src={icon} alt={alt ? alt : 'icon'} />
        </div>
      </div>
      <h4 className="just-start ubuntu">{header}</h4>
      <p className="just-start">{text}</p>
    </ServiceCardStyle>
  )
}

export default ServiceCard
